import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_6817_33420)">
      <path
        d="M12.5003 1.50042C12.148 1.48851 11.7986 1.43252 11.4603 1.33375L9.04025 0.667083C8.33358 0.45375 8.19358 0.500416 4.66692 0.500416C3.67185 0.49543 2.71065 0.861516 1.97101 1.52719C1.23138 2.19286 0.766415 3.11032 0.666919 4.10042L0.466919 7.50041C0.430895 8.19426 0.637357 8.87903 1.05091 9.43733C1.46447 9.99563 2.05935 10.3927 2.73359 10.5604C3.57359 10.7471 4.46025 10.8071 4.46025 11.7471V14.0004C4.46025 14.3982 4.61829 14.7798 4.89959 15.0611C5.1809 15.3424 5.56243 15.5004 5.96025 15.5004C6.35808 15.5004 6.73961 15.3424 7.02091 15.0611C7.30222 14.7798 7.46025 14.3982 7.46025 14.0004V12.9671C7.46025 11.641 7.98704 10.3692 8.92472 9.43155C9.8624 8.49387 11.1342 7.96708 12.4603 7.96708L12.5003 1.50042Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 0.5H12.5V9.5H15.5V0.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6817_33420">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
